import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'dp-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class ButtonComponent implements OnInit {
    @Input() public type = 'button';
    @Input() public title = '';
    @Input() public klass = '';
    @Input() public variant = 'primary';
    @Input() public size = '';
    @Input() public disabled: boolean;
    @Input() public full: boolean;
    @Input() public iconLeft: string;
    @Input() public iconRight: string;
    @Output() public click = new EventEmitter();
    public sizeClass: string;

    public ngOnInit() {
        if (this.size) {
            this.sizeClass = `btn-${this.size}`;
        }
    }

    public onClick(event) {
        this.click.emit(event);
    }
}
